import Mfo from 'assets/images/consortium/mfo.png'
import { Button } from 'components/atoms'
import Separator from 'components/landing/Separator'
import { type FC } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'

const MfoOffer: FC = () => (
  <Wrapper>
    <Separator />
    <Header>
      <Figure>
        <Image
          src={ Mfo }
        />
      </Figure>
      <Title>
        L'offre incontournable Ma Formation Officinale X Défimédoc !
      </Title>
      <Preface>
        {'Bénéficiez de réductions exclusives sur vos licences'}
      </Preface>
      <ButtonsWrapper>
        <OfferButton
          href="https://www.maformationofficinale.com/pages/loffre-ma-formation-officinale-x-defimedoc"
          size="medium"
          variant="primary"
        >
          {'Voir l\'offre'}
        </OfferButton>
      </ButtonsWrapper>
    </Header>
    <Separator />
  </Wrapper>
)

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
`

const Header = styled.div`
  margin: 0 20%;
  text-align: center;

  @media (width <= 1050px) {
    margin: 0 5%;
  }
`

const Title = styled.h2`
  font-family: "Brother 1816";
  font-size: 2.25rem;
  font-weight: bold;
  color: ${colors.midnightBlue};
  text-align: center;
`

const Preface = styled.p`
  margin: 3rem 0;
  color: ${colors.midnightBlue};
  text-align: center;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;

  &div:first-child {
    margin-right: 0;
  }
`

const OfferButton = styled(Button)`
  && {
    align-self: flex-start;
  }

  margin-bottom: 3rem;

  @media (width <= 1050px) {
    margin-right: auto;
    margin-left: auto;
  }
`

const Figure = styled.figure`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 1rem;
  margin: 0;
  margin-top: 2rem;
`

const Image = styled.img`
  width: auto;
  max-height: 100%;
`

export default MfoOffer
